import React, { useState } from "react";
import { Typography, Button } from "@mui/material";
import "./exerciseRecommendations.scss";
import { pageLocale } from "../../../utils/locale";

const ExerciseCard = ({ exercise, onSwitchExercise, hasOptions }) => {
  if (!exercise?.name) return null;

  const { frequency_duration, safety_considerations, other_option } =
    pageLocale("newreport");

  return (
    <div className="exercise-card">
      {exercise.aws_url && (
        <div className="exercise-img-wrapper">
          <img
            src={exercise.aws_url}
            alt={exercise.name}
            className="exercise-img"
          />
        </div>
      )}

      {exercise.how_to_do_it && (
        <div className="exercise-detail">
          <Typography className="exercise-title">{exercise.name}</Typography>
          <Typography className="detail-value">
            {exercise.how_to_do_it}
          </Typography>
        </div>
      )}

      {exercise.note && (
        <div className="exercise-detail note-section">
          <div className="note-content">
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clipPath="url(#clip0_75_962)">
                <path
                  d="M10.0001 18.3327C11.0946 18.334 12.1787 18.1191 13.1899 17.7002C14.2011 17.2813 15.1196 16.6668 15.8926 15.8919C16.6675 15.1189 17.2821 14.2004 17.701 13.1892C18.1198 12.1779 18.3348 11.0939 18.3334 9.99936C18.3348 8.90481 18.1198 7.82078 17.701 6.80956C17.2821 5.79834 16.6675 4.87984 15.8926 4.10686C15.1196 3.33192 14.2011 2.71736 13.1899 2.29849C12.1787 1.87961 11.0946 1.66467 10.0001 1.66602C8.90554 1.66467 7.82152 1.87961 6.81029 2.29849C5.79907 2.71736 4.88058 3.33192 4.10759 4.10686C3.33265 4.87984 2.7181 5.79834 2.29922 6.80956C1.88034 7.82078 1.6654 8.90481 1.66675 9.99936C1.6654 11.0939 1.88034 12.1779 2.29922 13.1892C2.7181 14.2004 3.33265 15.1189 4.10759 15.8919C4.88058 16.6668 5.79907 17.2813 6.81029 17.7002C7.82152 18.1191 8.90554 18.334 10.0001 18.3327Z"
                  stroke="#3b82f6"
                  strokeWidth="1.5"
                  strokeLinejoin="round"
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M10.0002 15.4154C10.2764 15.4154 10.5414 15.3056 10.7367 15.1103C10.9321 14.9149 11.0418 14.65 11.0418 14.3737C11.0418 14.0974 10.9321 13.8325 10.7367 13.6371C10.5414 13.4418 10.2764 13.332 10.0002 13.332C9.7239 13.332 9.45894 13.4418 9.26359 13.6371C9.06824 13.8325 8.9585 14.0974 8.9585 14.3737C8.9585 14.65 9.06824 14.9149 9.26359 15.1103C9.45894 15.3056 9.7239 15.4154 10.0002 15.4154Z"
                  fill="#3b82f6"
                />
                <path
                  d="M10 5V11.6667"
                  stroke="#3b82f6"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </g>
              <defs>
                <clipPath id="clip0_75_962">
                  <rect width="20" height="20" fill="white" />
                </clipPath>
              </defs>
            </svg>
            <Typography className="detail-value">{exercise.note}</Typography>
          </div>
        </div>
      )}

      {exercise.frequency_and_duration && (
        <div className="exercise-detail">
          <Typography className="detail-label">{frequency_duration}</Typography>
          <Typography className="detail-value">
            {exercise.frequency_and_duration}
          </Typography>
        </div>
      )}

      {(() => {
        const ignoredAdvises = ["generally safe", "一般的に安全", "一般安全"];
        const cautions = (exercise.caution || []).filter(
          (c) =>
            c.advice && !ignoredAdvises.includes(c.advice.trim().toLowerCase()),
        );

        if (cautions.length === 0) return null;

        return (
          <div className="exercise-detail cautions-section">
            <Typography className="detail-label">
              {safety_considerations}
            </Typography>
            <div className="cautions-list">
              {cautions.map((caution, i) => (
                <div key={i} className="caution-item">
                  <Typography className="caution-text">
                    <span className="caution-condition">
                      {caution.condition}:
                    </span>
                    <span className="caution-advice"> {caution.advice}</span>
                  </Typography>
                </div>
              ))}
            </div>
          </div>
        );
      })()}

      {hasOptions && (
        <div className="exercise-actions">
          <Button
            variant="contained"
            size="small"
            onClick={onSwitchExercise}
            className="other-option-btn"
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1 2.5C1 2.36739 1.05268 2.24022 1.14645 2.14645C1.24021 2.05268 1.36739 2 1.5 2H5.297C5.38678 1.99993 5.47491 2.02404 5.55216 2.06979C5.6294 2.11554 5.69291 2.18124 5.736 2.26L11 13H14.5C14.6326 13 14.7598 13.0527 14.8536 13.1464C14.9473 13.2402 15 13.3674 15 13.5C15 13.6326 14.9473 13.7598 14.8536 13.8536C14.7598 13.9473 14.6326 14 14.5 14H10.703C10.6132 14.0001 10.5251 13.976 10.4478 13.9302C10.3706 13.8845 10.3071 13.8188 10.264 13.74L5 3H1.5C1.36739 3 1.24021 2.94732 1.14645 2.85355C1.05268 2.75979 1 2.63261 1 2.5ZM11 2.5C11 2.36739 11.0527 2.24022 11.1464 2.14645C11.2402 2.05268 11.3674 2 11.5 2H14.5C14.6326 2 14.7598 2.05268 14.8536 2.14645C14.9473 2.24022 15 2.36739 15 2.5C15 2.63261 14.9473 2.75979 14.8536 2.85355C14.7598 2.94732 14.6326 3 14.5 3H11.5C11.3674 3 11.2402 2.94732 11.1464 2.85355C11.0527 2.75979 11 2.63261 11 2.5Z"
                fill="white"
              />
            </svg>
            {other_option}
          </Button>
        </div>
      )}
    </div>
  );
};

const ExerciseCategory = ({ category, onSwitchExercise }) => {
  const [currentExerciseIndex, setCurrentExerciseIndex] = useState(0);
  const { no_exercises_available } = pageLocale("newreport");

  const hasMain = category.exercise?.name;
  const hasOptions = category.options?.length > 0;
  const hasNote = category.note && category.note.trim() !== "";

  // If no exercises and no note, show "No exercises available"
  if (!hasMain && !hasOptions && hasNote) {
    return (
      <div className="exercise-category-box no-exercises">
        <Typography className="exercise-category-title">
          {category.exerciseCategory}
        </Typography>
        <div className="no-exercises-box">
          <svg
            width="90"
            height="90"
            viewBox="0 0 90 90"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M72.7501 35.1556L70.1701 32.5756L71.9701 30.6781C72.4526 30.1981 72.6939 29.6569 72.6939 29.0544C72.6939 28.4544 72.4526 27.9131 71.9701 27.4306L62.5651 18.0294C62.0851 17.5494 61.5451 17.3094 60.9451 17.3094C60.3451 17.3094 59.8039 17.5494 59.3214 18.0294L57.4239 19.8294L54.7501 17.1556L56.8426 14.9694C57.9426 13.8694 59.2914 13.3356 60.8889 13.3681C62.4864 13.4006 63.8351 13.9656 64.9351 15.0631L74.9364 25.0681C76.0364 26.1681 76.5864 27.5006 76.5864 29.0656C76.5864 30.6306 76.0364 31.9631 74.9364 33.0631L72.7501 35.1556ZM33.1576 74.8419C32.0576 75.9419 30.7251 76.4919 29.1601 76.4919C27.5951 76.4919 26.2626 75.9419 25.1626 74.8419L15.4501 65.1294C14.3001 63.9794 13.7251 62.5494 13.7251 60.8394C13.7251 59.1294 14.3001 57.7006 15.4501 56.5531L17.2501 54.7494L19.9276 57.4269L18.1014 59.2269C17.6214 59.7094 17.3814 60.2506 17.3814 60.8506C17.3814 61.4506 17.6214 61.9919 18.1014 62.4744L27.5289 71.8981C28.0089 72.3806 28.5489 72.6219 29.1489 72.6219C29.7489 72.6219 30.2901 72.3806 30.7726 71.8981L32.5726 70.0756L35.2501 72.7494L33.1576 74.8419ZM69.6564 49.3269L73.9201 45.0631C74.4001 44.5831 74.6401 44.0306 74.6401 43.4056C74.6401 42.7806 74.4001 42.2281 73.9201 41.7481L48.2514 16.0831C47.7714 15.6006 47.2189 15.3594 46.5939 15.3594C45.9689 15.3594 45.4164 15.5994 44.9364 16.0794L40.6726 20.3431C40.1926 20.8231 39.9526 21.3644 39.9526 21.9669C39.9526 22.5669 40.1926 23.1081 40.6726 23.5906L66.4126 49.3269C66.8926 49.8069 67.4326 50.0469 68.0326 50.0469C68.6326 50.0469 69.1739 49.8069 69.6564 49.3269ZM45.0639 73.9194L49.3276 69.6331C49.8076 69.1531 50.0476 68.6131 50.0476 68.0131C50.0476 67.4131 49.8076 66.8719 49.3276 66.3894L23.6101 40.6719C23.1301 40.1919 22.5889 39.9519 21.9864 39.9519C21.3864 39.9519 20.8464 40.1919 20.3664 40.6719L16.0801 44.9356C15.6001 45.4156 15.3601 45.9681 15.3601 46.5931C15.3601 47.2181 15.6001 47.7706 16.0801 48.2506L41.7489 73.9156C42.2289 74.3981 42.7814 74.6394 43.4064 74.6394C44.0314 74.6394 44.5839 74.3994 45.0639 73.9194ZM42.4089 54.1456L54.1651 42.4081L47.5876 35.8344L35.8539 47.5906L42.4089 54.1456ZM47.6664 76.5706C46.5189 77.7206 45.0989 78.2956 43.4064 78.2956C41.7139 78.2956 40.2926 77.7206 39.1426 76.5706L13.4289 50.8569C12.2789 49.7069 11.7039 48.2856 11.7039 46.5931C11.7039 44.9006 12.2789 43.4806 13.4289 42.3331L17.6889 37.9981C18.8389 36.8481 20.2689 36.2731 21.9789 36.2731C23.6889 36.2731 25.1176 36.8481 26.2651 37.9981L33.1801 44.9131L44.9364 33.1569L38.0214 26.2644C36.8714 25.1144 36.2964 23.6819 36.2964 21.9669C36.2964 20.2519 36.8714 18.8194 38.0214 17.6694L42.3526 13.3344C43.5026 12.1844 44.9314 11.6094 46.6389 11.6094C48.3464 11.6094 49.7764 12.1844 50.9289 13.3344L76.6651 39.0706C77.8151 40.2206 78.3901 41.6506 78.3901 43.3606C78.3901 45.0706 77.8151 46.4994 76.6651 47.6469L72.3339 51.9819C71.1839 53.1319 69.7501 53.7069 68.0326 53.7069C66.3151 53.7069 64.8826 53.1319 63.7351 51.9819L56.8426 45.0631L45.0864 56.8194L52.0014 63.7344C53.1514 64.8844 53.7264 66.3144 53.7264 68.0244C53.7264 69.7344 53.1514 71.1631 52.0014 72.3106L47.6664 76.5706Z"
              fill="#6E7276"
            />
          </svg>
          <Typography className="no-exercises-text">
            {no_exercises_available}
          </Typography>
          <Typography className="consult-text">{category.note}</Typography>
        </div>
      </div>
    );
  }

  // Get all exercises (main + options)
  const allExercises = [];
  if (hasMain) {
    allExercises.push(category.exercise);
  }
  if (hasOptions) {
    allExercises.push(...category.options);
  }

  const currentExercise = allExercises[currentExerciseIndex];
  const hasMultipleOptions = allExercises.length > 1;

  const handleSwitchExercise = () => {
    const nextIndex = (currentExerciseIndex + 1) % allExercises.length;
    setCurrentExerciseIndex(nextIndex);
    if (onSwitchExercise) {
      onSwitchExercise(category.exerciseCategory, nextIndex);
    }
  };

  return (
    <div className="exercise-category-box">
      <Typography className="exercise-category-title">
        {category.exerciseCategory}
      </Typography>
      <ExerciseCard
        exercise={currentExercise}
        onSwitchExercise={handleSwitchExercise}
        hasOptions={hasMultipleOptions}
      />
    </div>
  );
};

const ExerciseRecommendations = ({ exerciseData = [] }) => {
  const updateSelectedExercise = (categoryIndex, exerciseIndex) => {
    const url = new URL(window.location.href);
    const current = url.searchParams.get("selectedExercises");
    const selections = {};
    if (current) {
      current.split(",").forEach((pair) => {
        const [category, exercise] = pair.split(":");
        if (category !== undefined && exercise !== undefined) {
          selections[category] = exercise;
        }
      });
    }
    selections[categoryIndex] = exerciseIndex;
    url.searchParams.set(
      "selectedExercises",
      Object.entries(selections)
        .map(([category, exercise]) => `${category}:${exercise}`)
        .join(","),
    );
    window.history.replaceState(null, "", url.toString());
  };

  return (
    <div className="exercise-recommendations">
      <div className="exercise-categories">
        {exerciseData?.map?.((category, idx) => (
          <ExerciseCategory
            key={idx}
            category={category}
            onSwitchExercise={(categoryName, exerciseIndex) => {
              updateSelectedExercise(idx, exerciseIndex);
              console.log(
                `Switched to exercise ${exerciseIndex} in ${categoryName}`,
              );
            }}
          />
        ))}
      </div>
    </div>
  );
};

export default ExerciseRecommendations;
